<template>
    <div id="app">
        <router-view />
        <b-modal id="nist-modal" ok-only centered :visible="$route && $route.params && 'showNistWarning' in $route.params && $route.params.showNistWarning" no-close-on-backdrop no-close-on-esc>
            <div class="d-flex flex-column">
                WARNING:
                <p>
                    This information system may host technical data whose export is restricted by the Arms Export Control Act (Title 22, U.S.C., Sec 2751, et. seq.) or the Export Administrative Act of 1979, as amended, Title 50, U.S.C., App. 2401 et. seq.. Violations of these export laws are subject to severe criminal penalties. Contact your export compliance officer or system security officer if you have any questions about proper handling of this type of data. Continued use of this site constitutes acknowledgment that you have read and understand this warning.
                </p>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'app'
};
</script>

<style src="@/styles/main.scss" lang="scss"></style>
<style src="@dash/styles/dashboard.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue